export type IManagerUiSettings = {
  soundNotificationsEnabled: boolean;
};

export const SOUND_NOTIFICATIONS_ENABLED_DEFAULT = true;
